module.exports = __webpack_public_path__ + "static/media/social-photography.3697ea09.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/social-photography.png
// module id = 366
// module chunks = 0